'use client';

import Image, { ImageProps } from 'next/image';
import * as React from 'react';

import { cn } from '@/lib/utils';

interface FallbackImageProps extends ImageProps {
  className?: string;
  fallback?: ImageProps['src'];
}

export const FallbackImage: React.FC<FallbackImageProps> = ({
  className,
  fallback = 'https://placehold.co/400',
  alt,
  src,
  ...props
}) => {
  const [error, setError] = React.useState<React.SyntheticEvent<HTMLImageElement, Event> | null>(
    null
  );

  // Ensure src is never null or undefined. If it is, use the fallback immediately.
  const imageSrc = src || fallback;

  React.useEffect(() => {
    setError(null);
  }, [src]);

  return (
    <Image
      src={error ? fallback : imageSrc}
      alt={alt}
      className={cn(className)}
      onError={(event) => setError(event)}
      loading='lazy'
      draggable={false}
      quality={100}
      unoptimized
      {...props}
    />
  );
};
